import { NbAclOptions } from '@nebular/security';

// add here the operator admin resource
const OPERATOR_RESOURCES = ['dashboard', 'user', 'not-authorized'];

// add here the admin resource
const ADMIN_RESOURCES = ['dashboard', 'booking', 'user', 'not-authorized'];

export const acl: NbAclOptions = {
    accessControl: {
        guest: {
            view: ['not-authorized']
        },
        operator: {
            view: OPERATOR_RESOURCES,
            create: OPERATOR_RESOURCES,
            edit: OPERATOR_RESOURCES,
            remove: OPERATOR_RESOURCES
        },
        admin: {
            view: ADMIN_RESOURCES,
            create: ADMIN_RESOURCES,
            edit: ADMIN_RESOURCES,
            remove: ADMIN_RESOURCES
        }
    }
};
